import { Box } from "@mui/material";
import React, { useRef, useState } from "react";
import CustomModalBirthday from "components/customModalBirthday";
import "./index.scss";
import { useTheme } from "@emotion/react";

const InputComponent = ({
  type = "text",
  value = null,
  placeholder = "",
  handleValue = (e) => {},
  tabIndex,
  error = false,
  alertText = "",
  dir,
  readOnly = false,
  disabled = false,
  hasborder = false,
}) => {
  const inputRef = useRef(null);
  const theme = useTheme();
  const [openBirthdayModal, setOpenBirthdayModal] = useState(false);
  const [birthdayValue, setBirthdayValue] = useState(value);

  const handleBirthdayChange = (selectedDate) => {
    setBirthdayValue(selectedDate);
    handleValue(selectedDate);
    setOpenBirthdayModal(false);
  };

  return (
    <Box className="input-components">
      {type === "birthday" ? (
        <>
          <input
            ref={inputRef}
            type="text"
            placeholder={placeholder}
            value={birthdayValue || ""}
            onClick={() => setOpenBirthdayModal(true)}
            readOnly
            className={`${error ? "error" : ""}`}
            style={
              hasborder
                ? { border: `1px solid ${theme.palette.defultText.main}` }
                : {}
            }
            dir={dir}
            tabIndex={tabIndex}
            disabled={disabled}
          />
          <CustomModalBirthday
            open={openBirthdayModal}
            close={() => setOpenBirthdayModal(false)}
            setBirthday={handleBirthdayChange}
          />
        </>
      ) : (
        <input
          ref={inputRef}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => handleValue(e.target.value)}
          className={`${error ? "error" : ""}`}
          style={
            hasborder
              ? { border: `1px solid ${theme.palette.defultText.main}` }
              : {}
          }
          dir={dir}
          tabIndex={tabIndex}
          readOnly={readOnly}
          disabled={disabled}
        />
      )}
      <Box className="alert-text">
        {!!alertText && <span>{alertText}</span>}
      </Box>
    </Box>
  );
};

export default InputComponent;
